import { Modal, Button } from 'semantic-ui-react';
import MonthlyStatements from './monthlyStatements';
import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './statementsCSS.scss';
const MonthlyModal = (props) => {
  const tableRef = useRef();
  const { open, setClose } = props;
  const [selectedMonth, setSelectedMonth] = useState(null);

  const handleDateChange = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    setSelectedMonth(`${year}-${month}`);
  };
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 2);

  function PrintTableButton() {
    const handlePrint = useReactToPrint({
      content: () => tableRef.current,
    });

    return (
      <Button
        style={{ marginTop: 7, marginLeft: 10 }}
        key={`closeModal-${Math.random()}`}
        className={'add-line-item-btn rectangle'}
        basic
        color='green'
        circular
        compact
        onClick={handlePrint}
      >
        Print
      </Button>
    );
  }
  return (
    <Modal width='95%' className={'documentimageserviceschooser'} open={open}>
      <div style={{ width: '200px', display: 'inline-block' }} className='DateWrapper'>
        <DatePicker
          selected={selectedMonth ? new Date(selectedMonth) : null}
          onChange={handleDateChange}
          dateFormat='yyyy-MM'
          showMonthYearPicker
          minDate={minDate}
          maxDate={new Date()}
          placeholderText='Select a month'
          className='six-month-datepicker-container'
        />
      </div>
      <div ref={tableRef} >
        <MonthlyStatements selectedMonth={selectedMonth} />
      </div>
      <Button
        style={{ marginTop: 7, marginLeft: 10 }}
        key={`closeModal-${Math.random()}`}
        className={'add-line-item-btn rectangle'}
        basic
        color='blue'
        circular
        compact
        onClick={() => setClose()}
      >
        Close
      </Button>
      <PrintTableButton />
    </Modal>
  );
};
export default MonthlyModal;
